module.exports = "<section class=\"payUponInvoice\" id=\"payUponInvoice\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-pay-upon-invoice token=\"token\" is-unbranded=\"isUnbranded\"></xo-pay-upon-invoice>\n        </div>\n\n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!./pages/xo-pay-upon-invoice/template.html
// module id = ../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html
// module chunks = 0